<template>
  <div class="buyer-delivery-wrap">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/framework/myTrading/myOrder' }">我的订单</el-breadcrumb-item>
      <el-breadcrumb-item>卖方交收申请</el-breadcrumb-item>
    </el-breadcrumb>
    <header-title title="交收信息" />
    <content-table v-if="orderData.length !== 0" :tableData="orderData" labelWidth="130" />
    <div class="form_wrap">
      <el-row>
        <el-form label-width="100px">
          <el-col :span="8">
            <el-form-item label="升贴水单价" required>
              <el-input class="rule" v-model="create.areaPrice" placeholder="请填写升贴水单价" maxlength="10" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="移仓选择" required>
              <el-select class="rule" placeholder="请选择" v-model="create.moveWarehouseType">
                <el-option
                  v-for="(item, index) in this.$key.myOrder.moveWarehouseType"
                  :key="index"
                  :value="item.id"
                  :label="item.name" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="交货地">
              <el-input class="rule" placeholder="请填写交货地" v-model="create.deliveryAddress" maxlength="15" />
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="备注">
              <el-input class="rule remark_input" v-model="create.remark" maxlength="15" />
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </div>
    <delivery-data-table
      v-if="showDeliveryDataTable"
      v-model="deliveryDataList"
      :dataList="deliveryDataList"
      :buyerContractDate="buyerContractDate"
      :contract="contract"
      :contractDate="contractDate" />
    <div class="button-wrap">
      <el-button type="primary plain back_button" @click="back">返回</el-button>
      <el-button type="primary" @click="submit" :disabled="!sellerCanDelivery">提交申请</el-button>
    </div>
    <div class="warning-tip" v-if="!sellerCanDelivery">提示：该订单当前不可办理交收申请</div>
  </div>
</template>

<script>
import deliveryDataTable from './DeliveryDataTable'

function Create () {
  this.areaPrice = '' // 品牌补偿金
  this.moveWarehouseType = '' // 移仓方式
  this.deliveryAddress = '' // 交收地址
  this.liftingWater = '' // 升贴水
  this.remark = '' // 备注
}

export default {
  name: 'BuyerDelivery',
  components: {
    deliveryDataTable
  },
  data () {
    return {
      orderData: [], // 订单信息
      deliveryDataList: [], // 交收信息
      create: new Create(), // 表单信息
      buyerContractDate: '', // 买方定价合约日期
      contractDate: '', // 最后定价合约日期
      contract: '', // 最后定价合约
      showDeliveryDataTable: false, // 显示价格明细表格
      // 检验规则
      createRules: [
        { name: 'moveWarehouseType', message: '请选择移仓选择' }
      ],
      sellerCanDelivery: true // 当前是否可申请交收
    }
  },
  mounted () {
    this.getData()
    this.$route.query.applyId && this.getSellerDeliveryDetailData()
  },
  methods: {
    // 获取交收单数据
    getData () {
      const url = this.$API.myOrder.getContangoOrderDetail
      const param = {
        id: this.$route.params.id,
        directionType: this.$route.params.type
      }
      this.$http.post(url, param).then(res => {
        this.orderData = [ // 用于显示的订单信息
          { key: '会员号', value: res.data.contangoOrderVO.sellerAccount },
          { key: '开票单位', value: res.data.contangoOrderVO.sellerName },
          { key: '等级', value: res.data.contangoOrderVO.grade },
          { key: '品牌', value: res.data.contangoOrderVO.brandName },
          { key: '订单编号', value: res.data.contangoOrderVO.orderCode },
          { key: '订单数量', value: res.data.contangoOrderVO.orderQuantity },
          { key: '已交收数量', value: res.data.contangoOrderVO.sellerDeliveredQuantity },
          { key: '办理中数量', value: res.data.contangoOrderVO.sellerDeliveringQuantity },
          { key: '可交收数量', value: res.data.contangoOrderVO.sellerCanDeliveryQuantity }
        ]
        this.create.liftingWater = res.data.contangoVO.liftingWater // 升贴水
        this.create.areaPrice = res.data.contangoVO.liftingWater // 升贴水
        this.sellerCanDelivery = res.data.sellerCanDelivery // 当前是否可以交收
        this.contractDate = res.data.contractDate // 最后定价合约日期
        this.buyerContractDate = res.data.buyerContractDate // 买方定价合约日期
        this.contract = res.data.contangoVO.contract // 合约
        this.create.deliveryAddress = res.data.contangoVO.addressStr + res.data.contangoVO.wareHouseAddress // 交货地
        this.showDeliveryDataTable = true
      })
    },
    // 获取已交收单的数据（用于重新申请交收）
    getSellerDeliveryDetailData () {
      const url = this.$API.myOrder.mySellerDeliveryDetail
      const param = {
        id: this.$route.query.applyId
      }
      this.$http.post(url, param).then(res => {
        const data = res.data
        this.deliveryDataList = data.contangoOrderDeliveryDetailList // 交收信息
        this.create.moveWarehouseType = data.moveWarehouseType // 移仓选择
        this.create.deliveryAddress = data.deliveryAddress // 交收地址
        this.create.remark = data.remark // 备注
      })
    },
    // 在价格明细数组中找出填写了合同号和交收数量的项
    getValueList () {
      const list = this.deliveryDataList.filter(item => {
        return item.contractCode && item.quantity
      })
      return list
    },
    // 检查价格明细是否是空数组
    checkEmptyList () {
      const list = this.getValueList()
      if (list.length === 0) {
        this.$message.error('请填写价格明细（合同号和申请交收数量必填）')
        return true
      } else {
        return false
      }
    },
    // 返回
    back () {
      this.$router.go(-1)
    },
    // 提交申请
    submit () {
      if (!this.$utils.checkEmptyRules(this.create, this.createRules) && !this.checkEmptyList()) {
        // 有交收单ID走编辑的接口，没有的话走新增
        const url = this.$route.query.applyId ? this.$API.myOrder.editSellerDeliveryApply : this.$API.myOrder.addSellerDeliveryApply
        let param = {
          sellerAccount: this.orderData[0].value,
          sellerName: this.orderData[1].value,
          orderCode: this.orderData[4].value,
          brandName: this.orderData[3].value,
          grade: this.orderData[2].value,
          contangoOrderDeliveryDetailList: this.getValueList()
        }
        param = this.$utils.objectAssign(param, this.create)
        if (this.$route.query.applyId) { // 编辑的时候，把交收单id带过去
          param.id = this.$route.query.applyId
        }
        this.$http.post(url, param).then((res) => {
          if (res.succeed) {
            this.$message.success('提交成功')
            this.$router.push({ path: '/framework/myTrading/myOrder' })
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .buyer-delivery-wrap{
    margin-top: 20px !important;
    .form_wrap{
      margin-top: 25px;
      margin-bottom: 10px;
      padding: 0 30px;
      .remark_input{
        width: 598px;
      }
    }
    .table_input{
      width: 80%;
    }
    .add_button{
      font-size: 14px;
      color: #ff7f00;
      line-height: 40px;
      cursor: pointer;
      width: 150px;
      span{
        margin-left: 8px;
      }
    }
    .button-wrap{
      display: flex;
      justify-content: center;
      align-items: center;
      button{
        margin-top: 62px;
        margin-bottom: 20px;
      }
      .back_button{
        width: 110px;
      }
    }
  }
</style>
